const zhComic = {
  status: {
    ongoing: '连载中',
    completed: '已完结',
  },
  info: {
    author: '作者',
    artist: '作画',
    genre: '题材',
    chapters: '章节数',
    rating: '评分',
    reads: '阅读量',
    lastUpdate: '最近更新',
  },
  desc: '作品简介',
  chapters: {
    title: '章节列表',
    latest: '最新章节',
  },
  reviews: {
    title: '读者评论',
    writeReview: '写评论',
    loadMore: '加载更多评论',
  },
  cta: {
    line1: '准备好沉浸式体验了吗？',
    line2: '立即开始阅读',
    line3: '下一章更精彩',
    btn: '开始阅读第一章',
  },
};

export default zhComic;